<div>
  <div class="col-12">
    <label class="headerName">Product settings</label>
  </div>
  <div class="col-12">
    <label class="subTitleName">Details</label>
  </div>
  <div class="mainProductDetails" [ngClass]="{ 'disabled-popup': !showEdit }">
    <form [formGroup]="productProjectForm">
      <div class="row">
        <div class="col-sm-12">
          <div class="form-group required">
            <piqet-angular-common-input
              label="Product name"
              name="productName"
              placeholder="Product name"
              formControlName="productName"
              [control]="productProjectForm.controls['productName']"
              [submitted]="submitted"
              [maxLength]="50"
              [preventDot]="true"
            ></piqet-angular-common-input>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="form-group descriptionField">
          <div class="services-form">
            <textarea
              formControlName="description"
              cols="20"
              id="Description"
              name="Description"
              rows="2"
              placeholder="Description"
            ></textarea>
            <label>Description</label>
          </div>
        </div>
      </div>

      <!-- File uploaded -->
      <div class="row mt-3">
        <piqet-angular-file-upload
          type="image"
          [customConfig]="{
            selectButtonText: 'Select file',
            changeButtonText: 'Change',
            removeButtonText: 'Remove',
            placeholderText: 'Project image',
            acceptedFileTypes: ['image/png', 'image/jpg', 'image/jpeg', 'image/gif'],
            acceptAttribute: '.png,.jpg,.jpeg,.gif',
            maxFileSize: 5,
            showPreview: true,
            customErrorMessage: 'Only .jpg,.png,.jpeg,.gif file allowed'
          }"
          [existingFileUrl]="productImage"
          [existingFileName]="existingFileName"
          (fileSelected)="onFileSelected($event)"
          (removeConfirmation)="deleteConfirmation()"
          #fileUploadComponent
          customClass="col-sm-6 form-group"
        >
        </piqet-angular-file-upload>
      </div>

      <!-- Country -->
      <div class="row">
        <label class="countryLable">{{ projectsPlaceholder.PROCESS_COUNTRY_LABEL }}</label>
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <div class="form-group countryDropDown">
            <ng-select
              [clearable]="false"
              #country
              [items]="defaultRegionItems"
              [searchable]="false"
              bindLabel="name"
              formControlName="country"
              [searchFn]="commonInputSearch"
              [ngClass]="
                productProjectForm.controls['country'].value?.length > 11 ? 'multi-select' : ''
              "
              [multiple]="true"
              [placeholder]="projectsPlaceholder.PROCESS_COUNTRY"
              (change)="defalutCountry($event)"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    placeholder="Search..."
                    type="text"
                    class="form-control accordion-search search-input"
                    id="inputValidation"
                    (input)="country.filter($any($event.target).value)"
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
              </ng-template>
            </ng-select>
          </div>
        </div>
      </div>
      <div class="row">
        <label class="countryLable">{{ projectsPlaceholder.DEFAULT_COUNTRY_LABEL }}</label>
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <div class="form-group required">
            <ng-select
              [clearable]="true"
              [clearOnBackspace]="false"
              #defaultCountry
               [items]="selectCountry || defaultRegionItems"
              [searchable]="false"
              bindLabel="name"
              formControlName="defaultCountry"
              [searchFn]="commonInputSearch"
              [placeholder]="projectsPlaceholder.DEFAULT_COUNTRY"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    placeholder="Search..."
                    type="text"
                    class="form-control accordion-search search-input"
                    id="inputValidation"
                    (input)="defaultCountry.filter($any($event.target).value)"
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
              </ng-template>
            </ng-select>
            <div
              *ngIf="
                (productProjectForm.controls['defaultCountry']?.touched &&
                  productProjectForm.controls['defaultCountry']?.invalid) ||
                (submitted && !productProjectForm.controls['defaultCountry'].value?.name)
              "
              class="input-error"
            >
              Country is required
            </div>
          </div>
        </div>
      </div>

      <!-- turn on cost -->
      <div class="row pb-3">
        <div class="col-sm-4">
          <div class="d-flex w-100 justify-content-between align-items-center checkboxview">
            <div class="d-flex checkBoxAlienMent">
              <div>
                <input
                  type="checkbox"
                  class="chkOverview"
                  [ngModelOptions]="{ standalone: true }"
                  [(ngModel)]="isCostTurnedOff"
                  (change)="costTurnOff($event)"
                />
              </div>
              <div><span class="checkbox-style switch-cost">Switch on cost</span></div>
            </div>
          </div>
        </div>
      </div>

      <div class="row pb-3" *ngIf="showCurrencyList">
        <div class="col-sm-12 currencyTab">
          <div class="project-spacing currency-drpdown">
            <ng-select
              [clearable]="true"
              [clearOnBackspace]="false"
              #currency
              [items]="currencyList"
              (change)="selectCurrency($event)"
              [searchable]="false"
              bindLabel="name"
              formControlName="currency"
              [searchFn]="commonInputSearch"
              placeholder="Currency"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    type="text"
                    class="form-control accordion-search search-input"
                    id="inputValidation"
                    placeholder="Search..."
                    (input)="currency.filter($any($event.target).value)"
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
              </ng-template>
            </ng-select>
            <div
              *ngIf="
                (submitted || productProjectForm.controls['currency']?.touched) &&
                productProjectForm.controls['currency']?.invalid
              "
              class="input-error"
            >
              Currency is required.
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div>
          <div class="input-div">
            <label *ngIf="productProjectForm.get('unit')?.value" class="sub-header-drpdown pb-2"
              >Unit *</label
            >
            <ng-select
              [clearable]="true"
              [clearOnBackspace]="false"
              #unit
              [items]="unitList"
              formControlName="unit"
              [searchable]="false"
              bindLabel="name"
              placeholder="Unit *"
              bindValue="id"
              (change)="changeUnit($event)"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    type="text"
                    class="form-control accordion-search search-input"
                    id="inputValidation"
                    placeholder="Search..."
                    (input)="unit.filter($any($event.target).value)"
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
              </ng-template>
            </ng-select>
          </div>
          <div
            *ngIf="
              (submitted || productProjectForm.controls['unit']?.touched) &&
              productProjectForm.controls['unit']?.invalid
            "
            class="input-error"
          >
            Unit is required.
          </div>
        </div>
      </div>

      <div class="d-flex pb-3 col-8 productScope mt-4">
        <ng-container *ngFor="let item of productScope; let i = index">
          <div class="d-flex checkBoxAlienMent">
            <span
              [ngbTooltip]="
                isIngredientScope(item) ? 'Ingredients is mandatory and cannot be unchecked' : ''
              "
              placement="top"
              tooltipClass="sku-tooltip"
              container="body"
            >
              <input
                type="checkbox"
                id="{{ item.id }}"
                class="chkOverview projectScopeChecks"
                [checked]="item.selected"
                [disabled]="isIngredientScope(item)"
                (change)="selectedProductScope($event, item.id)"
              />
            </span>
            <div>
              <span class="checkbox-style" [class.disabled-text]="isIngredientScope(item)">{{
                item.name
              }}</span>
            </div>
          </div>
        </ng-container>
      </div>

      <hr class="hr" />
      <div class="row">
        <div class="form-group">
          <label
            id="goalAndScope"
            *ngIf="productProjectForm.controls['goalAndScope']?.value"
            class="sub-header-drpdown pb-2"
            >Goal and scope</label
          >
          <span
            *ngIf="productProjectForm.controls['goalAndScope']?.value"
            class="ps-3 tooltip-header"
            placement="auto"
            tooltipClass="sku-tooltip"
            ngbTooltip="Specify the reason for the study."
          >
            <img src="./assets/icons/grey-question-icon.svg" width="16" height="16"
          /></span>
          <div class="services-form">
            <textarea
              formControlName="goalAndScope"
              class="resizable-textarea"
              cols="20"
              id="Description"
              name="Description"
              rows="2"
              placeholder="Goal and scope"
            ></textarea>
            <label *ngIf="!productProjectForm.controls['goalAndScope']?.value"
              >Goal and scope</label
            >
          </div>
        </div>
        <div class="form-group">
          <label
            *ngIf="productProjectForm.controls['otherLimitations']?.value"
            class="sub-header-drpdown pb-2"
            >Other assumptions/limitations</label
          >
          <span
            *ngIf="productProjectForm.controls['otherLimitations']?.value"
            class="ps-3 tooltip-header"
            placement="auto"
            tooltipClass="sku-tooltip"
            ngbTooltip="List all value choices, assumptions or limitations that may affect any of the impact category results."
          >
            <img src="./assets/icons/grey-question-icon.svg" width="16" height="16"
          /></span>
          <div class="services-form categoryJustification">
            <textarea
              formControlName="otherLimitations"
              class="resizable-textarea"
              cols="20"
              id="Description"
              name="Description"
              rows="2"
              placeholder="Other assumptions/limitations"
            ></textarea>
            <label *ngIf="!productProjectForm.controls['otherLimitations']?.value"
              >Other assumptions/limitations</label
            >
          </div>
        </div>
        <div class="form-group">
          <label
            *ngIf="productProjectForm.controls['interpretation']?.value"
            class="sub-header-drpdown pb-2"
            >Interpretation</label
          >
          <div class="services-form categoryJustification">
            <textarea
              formControlName="interpretation"
              class="resizable-textarea"
              cols="20"
              id="Description"
              name="Description"
              rows="2"
              placeholder="Interpretation"
            ></textarea>
            <label *ngIf="!productProjectForm.controls['interpretation']?.value"
              >Interpretation</label
            >
          </div>
        </div>
      </div>

      <!-- Buttons -->
      <div class="modal-footer justify-content-start">
        <button
          type="button"
          class="modelBtn purpleBtnHoverEffect"
          (click)="updateProductProject()"
          *ngIf="showEdit"
        >
          Save
        </button>
        <button
          type="button"
          (click)="nextPage()"
          [disabled]="!productProjectForm.valid"
          class="next-btn modelBtn"
        >
          Next <i class="bi bi-arrow-right checkbox-div"></i>
        </button>
      </div>
    </form>
  </div>
</div>
